module.exports = __webpack_public_path__ + "img/stock5.d61a91da.png";